import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
// Styles
import { BannerContent, BannerWrap } from './Banner.styles';
// Image
import nflLogo from "../../assets/logo/logo.png";
import {
  fetchCommonSettings,
  selectCommonYear,
} from "../../app/features/commonSettings/commonSettingsSlice";

const Banner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const draftYear = useSelector(selectCommonYear);

  useEffect(() => {
    dispatch(fetchCommonSettings());
  }, [dispatch]);

  return (
    <BannerWrap onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
      <BannerContent>
        <h2>{`DRAFT PROFESSOR ${draftYear}`}</h2>
        <img src={nflLogo} alt="Logo" />
      </BannerContent>
    </BannerWrap>
  );
}

export default Banner
